import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const Portal = (props) => {
  const { children, mountNode } = props;

  const [myDocument, setMyDocument] = useState(null)
  useEffect(() => {
    if(mountNode) {
      setMyDocument(mountNode)
      return
    }
    setMyDocument(document.body)
  }, [])

  if(!myDocument) {
    return null;
  }

  return ReactDOM.createPortal(
    children,
    myDocument
  );
}

export default Portal;